import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { LoginComponent } from './login/login.component';
import { AuthComponent } from './auth.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import { SsoCallbackComponent } from './sso-callback/sso-callback.component';

const routes: Routes = [
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'login/reset',
        component: ResetPasswordComponent,
      },
      {
        path: 'ssoCallback',
        component: SsoCallbackComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule {}
